import { Link } from "react-router-dom"

export const EmployeeLink = ({ name, username }) => {
  return username ? (
    <Link
      to={`/staff/${username}`}
      className="text-decoration-none text-primary"
    >
      {name ?? "Unknown Name"}
    </Link>
  ) : (
    <span className="text-muted">{name ?? "Unknown Name"}</span>
  )
}
